/* global BaseUrl, Version  */
import { setCookie, getCookie, removeCookie } from 'helpers/Storage';
import { getAccountCookie, getLegacyDomain, convertTimestamp } from '../helpers/Account';

export const AUTH_STATUS = {
  UNINITIALIZED: 'Uninitialized',
  INITIALIZED: 'Initialized',
  REFRESH_STARTED: 'Starting to checking refresh token',
  REFRESH_ATTEMPTING: 'Refresh Attempting',
  REFRESH_SUCCESS: 'Refresh Success',
  REFRESH_FAILED: 'Refresh Failed',
  LOGIN_STARTED: 'Login Started',
  LOGIN_FAILED: 'Login Failed',
  LOGIN_SUCCESS: 'Login Success',
  LOGOUT_STARTED: 'Logout Started',
  LOGOUT_FAILED: 'Logout Failed',
  LOGOUT_SUCCESS: 'Logout Success',
  CHECK_AUTH_STARTED: 'Check authentication Started',
  CHECK_AUTH_FAILED: 'Check authentication Failed',
  CHECK_AUTH_SUCCESS: 'Check authentication Success',
  MVPD_LOGIN_STARTED: 'MVPD Login Started',
  MVPD_LOGIN_FAILED: 'MVPD Login Failed',
  MVPD_LOGIN_SUCCESS: 'MVPD Login Success',
  MVPD_LOGOUT_STARTED: 'MVPD Logout Started',
  MVPD_LOGOUT_FAILED: 'MVPD Logout Failed',
  MVPD_LOGOUT_SUCCESS: 'MVPD Logout Success',
  ANON_LOGIN_STARTED: 'Anonymous Login Started',
  ANON_LOGIN_FAILED: 'Anonymous Login Failed',
  ANON_LOGIN_SUCCESS: 'Anonymous Login Success',
  ANON_LOGIN_DELETED: 'Anonymous Login Deleted',
  MVPD_DOES_NOT_EXIST: 'MVPD Does Not Exist',
  ENTITLEMENT_SUCCESS: 'Fetch Entitlement Success',
  ENTITLEMENT_FAILED: 'Fetch Entitlement Failed',
  PREAUTH_SUCCESS: 'Preauth Success',
  PREAUTH_FAILED: 'Preauth Failed',
};

const NATSSO_COOKIE = 'NATSSO';
export const MVPD_COOKIE_NAME = 'mvpd-auth';

export const VERSION = Version;
export const REQUESTOR = 'fbc-fox';
export const FIRST_SCREEN = true; // Second screen is the SSA

const PREVIEW_PASS_5_MVPD = 'TempPass_fbcfox_5min';
const PREVIEW_PASS_60_MVPD = 'TempPass_fbcfox_60min';

const helperGetBaseUrlSlug = () => window.ExternalConfig?.baseUrlSlug || '';

export const getAuthRedirectUrl = () => {
  const baseUrlSlug = helperGetBaseUrlSlug();
  return `${BaseUrl}${baseUrlSlug}/static/html/auth_success_landing.html`;
};

export const isPreviewPass = mvpd => mvpd === PREVIEW_PASS_5_MVPD || mvpd === PREVIEW_PASS_60_MVPD;

const ONE_YEAR = 365 * 24 * 60 * 60 * 1000;

const cookieOptions = value => {
  const expires = convertTimestamp(value?.authn_expire || value?.tokenExpiration * ONE_YEAR);
  return {
    domain: getLegacyDomain(),
    path: '/',
    expires,
  };
};

export const setMVPDCookie = value => {
  setCookie({ name: MVPD_COOKIE_NAME, value, options: cookieOptions(value) });
};

export const getMVPDCookie = () => getCookie({ name: MVPD_COOKIE_NAME });

export const removeMVPDCookie = () => {
  removeCookie({ key: MVPD_COOKIE_NAME, options: { domain: getLegacyDomain(), path: '/' } });
};

export const getCurrentAuthData = () => {
  const account = getAccountCookie();
  const authData = account;
  const profileId = authData?.profileId;
  const currentAccessToken = authData?.accessToken;
  const refreshToken = authData?.refreshToken;

  return {
    authData,
    profileId,
    accessToken: currentAccessToken,
    refreshToken,
  };
};

export const isTimestampExpired = timestamp => {
  const current = new Date();
  const expiration = new Date(timestamp);
  if (!expiration.getTime() || current > expiration) return true;
  return false;
};

export const manageAccountCookies = authState => {
  const { account, anonymousAccount } = authState || {};
  const user = account || anonymousAccount;
  setFoxNewsCookie(user);
};

export const setFoxNewsCookie = value => {
  const { accessToken, refreshToken, tokenExpiration, profileId } = value;
  setCookie({
    name: NATSSO_COOKIE,
    value: { accessToken, refreshToken, tokenExpiration, profileId },
    options: { path: '/', domain: '.foxnews.com' },
  });
};
